export const adminSupportPromptTemplatesApi = {

    getAll () {
        return axios.get('/api/admin/support-prompt-template')
    },

}
